export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/ac478f259eebce517c6cc06e4306b00d.svg";